<template>
    <ProductGetDiv>
        <ProductGetHeaderArea>
            <ProductGetTitleArea>
                <Domain />&nbsp;&nbsp;&nbsp;<span>내 창고</span>
            </ProductGetTitleArea>

            <!-- ! 검색창 및 최근 주문 품목 -->
            <ProductGetSearchArea>
                <SearchLeftArea>
                    <ProductGetSearchBtn @click="openProductModal">
                        <Plus :size="25" style="padding-top: 2px" />신규품목 추가
                    </ProductGetSearchBtn>
                </SearchLeftArea>
                <SearchRightArea>
                    <ProductGetSearchInputTxt type="text" placeholder="거래처, 품목분류, 품목명 검색 Enter" v-model="searchQuery"
                        @keyup.enter="fetchData" @focus="disableBarcodeScanner" />
                    <ProductGetSearchBtn @click="fetchData">
                        <Magnify />
                    </ProductGetSearchBtn>
                </SearchRightArea>
            </ProductGetSearchArea>
        </ProductGetHeaderArea>

        <!-- ! 카테고리 Area -->
        <ProductGetBodyArea>
            <ProductGetBodyCategory>
                <ProductGetBodyCategoryEtc>
                    <div style="color: #cc5803;">세트</div>
                    <ProductGetBodyCategoryEtcBtnArea>
                        <div>
                            <ProductGetBodyCategoryRentBtn :class="{ active: selectedSetCategory === '세트' }"
                                @click="searchBySetCategory('세트')">
                                세트품목
                            </ProductGetBodyCategoryRentBtn>
                        </div>
                    </ProductGetBodyCategoryEtcBtnArea>
                </ProductGetBodyCategoryEtc>

                <ProductGetBodyCategoryBuy>
                    <div style="color: #cc5803;">구매 및 대여</div>
                    <ProductGetBodyCategoryBuyBtnArea>
                        <div v-for="(group, groupIndex) in categoryGroups" :key="'group-' + groupIndex">
                            <template v-for="(category, catIndex) in group" :key="'cat-'+groupIndex+'-'+catIndex">
                                <ProductGetBodyCategoryBuyBtn :class="{ active: selectedCategory === category.value }"
                                    @click="searchByCategory(category.value)">
                                    {{ category.name }}
                                </ProductGetBodyCategoryBuyBtn>
                            </template>
                        </div>
                    </ProductGetBodyCategoryBuyBtnArea>
                </ProductGetBodyCategoryBuy>

                <ProductGetBodyCategoryEtc>
                    <div style="color: #cc5803;">산소발생기</div>
                    <ProductGetBodyCategoryEtcBtnArea>
                        <div>
                            <ProductGetBodyCategoryRentBtn :class="{ active: selectedOxygenCategory === '호흡(석션용품)' }"
                                @click="searchByOxygenCategory('호흡(석션용품)')">호흡(석션용품)
                            </ProductGetBodyCategoryRentBtn>
                        </div>
                    </ProductGetBodyCategoryEtcBtnArea>
                </ProductGetBodyCategoryEtc>

                <ProductGetBodyCategoryEtc>
                    <div style="color: #cc5803;">보조기기</div>
                    <ProductGetBodyCategoryEtcBtnArea>
                        <div v-for="(group, groupIndex) in groupedAssistanceCategories"
                            :key="'assist-group-' + groupIndex">
                            <template v-for="(category, catIndex) in group"
                                :key="'assist-cat-'+groupIndex+'-'+catIndex">
                                <ProductGetBodyCategoryRentBtn
                                    :class="{ active: selectedAssistanceCategory === category.value }"
                                    @click="searchByAssistanceCategory(category.value)">
                                    {{ category.name }}
                                </ProductGetBodyCategoryRentBtn>
                            </template>
                        </div>
                    </ProductGetBodyCategoryEtcBtnArea>
                </ProductGetBodyCategoryEtc>
            </ProductGetBodyCategory>

            <!-- ! 품목 테이블 -->
            <ProductGetBodyTable>
                <ProductGetBodyTableThead>
                    <tr>
                        <th>거래처</th>
                        <th>품목분류</th>
                        <th>바코드/보험코드</th>
                        <th>품목명</th>
                        <th>사이즈</th>
                        <th>색상</th>
                        <th>재고위치</th>
                        <th>구입/대여</th>
                        <th>급여/비급여</th>
                        <th>단가</th>
                        <th>이미지보기</th>
                    </tr>
                </ProductGetBodyTableThead>
                <ProductGetBodyTableTbody>
                    <tr v-for="(product, index) in filteredproducts" :key="index">
                        <td @click="productDetail(product)">{{ product.company }}</td>
                        <td @click="productDetail(product)">{{ product.num >= 1000000 ? product.name0 : product.name }}
                        </td>
                        <td @click="productDetail(product)">
                            {{ product.num >= 1000000 ? product.bcode || '' : product.code || '' }}
                            {{ product.name0?.startsWith('당뇨용품') && product.icode ? ` (${product.icode})` : '' }}
                        </td>
                        <td @click="productDetail(product)">{{ product.num >= 1000000 ? product.name2 : product.name2 }}
                        </td>
                        <td @click="productDetail(product)">{{ product.size }}</td>
                        <td @click="productDetail(product)">{{ product.color }}</td>
                        <td @click="productDetail(product)">{{ product.location }}</td>
                        <td @click="productDetail(product)">
                            <template v-if="product.target === '구입 또는 대여'">
                                <TargetToggleContainer @click.stop>
                                    <TargetButton :class="{ active: product.selected_target === '구입' }"
                                        @click="updateTarget(product, '구입')">
                                        구입
                                    </TargetButton>
                                    <TargetDivider>|</TargetDivider>
                                    <TargetButton :class="{ active: product.selected_target === '대여' }"
                                        @click="updateTarget(product, '대여')">
                                        대여
                                    </TargetButton>
                                </TargetToggleContainer>
                            </template>
                            <template v-else>
                                {{ product.target }}
                            </template>
                        </td>
                        <td @click="productDetail(product)">{{ product.num >= 1000000 ? '비급여' : '급여' }}</td>
                        <td @click="productDetail(product)">
                            <template v-if="product.target === '구입 또는 대여'">
                                {{ product.selected_target === '구입' ? formatPrice(product.buyprice) :
                                    product.selected_target === '대여' ? formatPrice(product.rentprice) :
                                        `${formatPrice(product.buyprice)}/${formatPrice(product.rentprice)}` }}
                            </template>
                            <template v-else-if="product.target === '구입'">
                                {{ formatPrice(product.buyprice) }}
                            </template>
                            <template v-else-if="product.target === '대여'">
                                {{ formatPrice(product.rentprice) }}
                            </template>
                        </td>
                        <td>
                            <HanqBtn @click.stop="showProductImage(product)">보기</HanqBtn>
                        </td>
                    </tr>
                </ProductGetBodyTableTbody>
            </ProductGetBodyTable>

            <!-- ! 품목 상세보기 이미지 -->
            <ProductImageModal v-if="selectedProduct && imageUrl" @click.self="closeProductImage">
                <ProductImageContainer>
                    <ProductImageTitle>
                        {{ selectedProduct.num >= 1000000 ? selectedProduct.name3 : selectedProduct.name2 }}
                    </ProductImageTitle>
                    <ProductImageWrapper>
                        <img :src="imageUrl" :alt="selectedProduct?.name2" @error="handleImageError"
                            class="product-image" />
                    </ProductImageWrapper>
                    <CloseButton @click="closeProductImage">&times;</CloseButton>
                </ProductImageContainer>
            </ProductImageModal>

        </ProductGetBodyArea>
    </ProductGetDiv>

    <!-- ! 신규 품목 등록 모달 -->
    <ModalPage v-model:show="showModal_obj.product_new" :width="modal_width.product_new"
        :height="modal_height.product_new">
        <ProductAddNewModal @productAdded="handleProductAdded" @closeModal="closeProductModal" />
    </ModalPage>
</template>

<script>
import { reactive, ref } from 'vue';
import * as injectGlobal from '@/assets/styles/global/public.js';
import ModalPage from '@/components/layout/ModalPage.vue';
import * as ProductGetCss from '@/assets/styles/product/modal/ProductGetCss.js';
import ProductAddNewModal from '@/components/product/modal/ProductAddModal.vue'

import Domain from 'vue-material-design-icons/Domain.vue';
import Magnify from 'vue-material-design-icons/Magnify.vue';
import Plus from 'vue-material-design-icons/Plus.vue';

import onScan from 'onscan.js';

export default {
    name: 'ProductGetPage',

    components: {
        ...injectGlobal,
        ModalPage,
        ...ProductGetCss,
        ProductAddNewModal,
        Domain, Magnify, Plus
    },

    emits: ['productDetail', 'close', 'updateProduct', 'selectTarget'],

    props: {
        existingProducts: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            categories: [],
            categoryLevel1: [],
            categoryLevel2: {},
            categoryGroups: [],
            assistanceCategories: [],
            additionalCategories: [
                { name: '이동욕조', value: '이동욕조' },
                { name: '목욕의자', value: '목욕의자' },
                { name: '배회감지기', value: '배회감지기' },
                { name: '안전손잡이', value: '안전손잡이' },
                { name: '경사로(실외용)', value: '경사로(실외용)' },
                { name: '경사로(실내용)', value: '경사로(실내용)' },
                { name: '미끄럼 방지용품', value: '미끄럼 방지용품' },
                { name: '욕창예방방석', value: '욕창예방방석' },
                { name: '욕창예방 매트리스', value: '욕창예방 매트리스' },
                { name: '성인용보행기', value: '성인용보행기' },
                { name: '수동휠체어', value: '수동휠체어' },
                { name: '자세변환용구', value: '자세변환용구' },
                { name: '수동침대', value: '수동침대' },
                { name: '전동침대', value: '전동침대' },
                { name: '이동변기', value: '이동변기' },
                { name: '간이변기', value: '간이변기' },
                { name: '요실금팬티', value: '요실금팬티' },
            ]
        }
    },

    setup() {
        const selectedProduct = ref(null);
        const isDefaultImage = ref(false);
        const isLoading = ref(false);
        const showProductModal = ref(false);
        const selectedCategory = ref('');
        const selectedOxygenCategory = ref(null);
        const selectedAssistanceCategory = ref(null);
        const selectedSetCategory = ref(null);

        const showModal_obj = reactive({
            product_detail: ref(false),
            product_new: ref(false),
        });
        const modal_width = {
            product_detail: '80%',
            product_new: '70%',
        };
        const modal_height = {
            product_detail: '80%',
            product_new: '80%',
        };

        return {
            products_info: reactive({
                products: [],
                total_cnt: 0,
            }),
            searchQuery: '',
            selectedProduct,
            isDefaultImage,
            imageUrl: '',
            isLoading,
            showProductModal,
            selectedCategory,
            selectedOxygenCategory,
            selectedAssistanceCategory,
            selectedSetCategory,
            showModal_obj,
            modal_width,
            modal_height,
        };
    },

    computed: {
        // 보조기기 카테고리 그룹화 (3개씩)
        groupedAssistanceCategories() {
            const groups = [];
            for (let i = 0; i < this.assistanceCategories.length; i += 3) {
                const group = [];
                for (let j = 0; j < 3 && i + j < this.assistanceCategories.length; j++) {
                    group.push(this.assistanceCategories[i + j]);
                }
                if (group.length > 0) {
                    groups.push(group);
                }
            }
            return groups;
        },
        // 검색 결과 품목 필터링
        filteredproducts() {
            return this.products_info.products;
        },
        existingTarget() {
            const allProducts = Array.isArray(this.existingProducts) ? this.existingProducts : [];

            if (allProducts.length === 0) return null;

            // 모든 제품이 같은 target을 가지고 있는지 확인
            const firstTarget = allProducts[0].selected_target || allProducts[0].target;
            const isConsistent = allProducts.every(p => (p.selected_target || p.target) === firstTarget);

            if (isConsistent) {
                return firstTarget;
            } else {
                // 일관되지 않으면 null 반환하거나 에러 처리
                console.warn('주문 내역의 제품들이 서로 다른 구입/대여 타입을 가지고 있습니다.');
                return null;
            }
        }
    },

    mounted() {
        this.fetchData();
    },

    methods: {
        async fetchAllCategories() {
            try {
                const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAllCategories`, {
                    params: { companykey: this.$globalState.company_key }
                });

                if (response.data.success) {
                    this.categories = response.data.data;
                    this.categoryLevel1 = this.categories.map(cat => cat.name);

                    // 하위 카테고리 매핑
                    this.categories.forEach(cat => {
                        this.categoryLevel2[cat.name] = cat.subcategories.map(subcat => subcat.name);
                    });

                    // 보조기기 카테고리의 서브카테고리 저장
                    const assistanceCategory = this.categories.find(cat => cat.name === '보조기기');
                    if (assistanceCategory && assistanceCategory.subcategories) {
                        this.assistanceCategories = assistanceCategory.subcategories.map(subcat => ({
                            name: subcat.name,
                            value: subcat.name
                        }));
                    }

                    // 카테고리를 3개씩 그룹화
                    this.groupCategories();
                }
            } catch (error) {
                console.error('카테고리 정보 불러오기 실패:', error);
            }
        },

        groupCategories() {
            // 제외할 카테고리 목록
            const excludeCategories = ['호흡(석션용품)', '보조기기', '기타용품'];

            // 제외할 카테고리를 필터링한 카테고리 목록
            const filteredCategories = this.categories.filter(category =>
                !excludeCategories.includes(category.name)
            );

            // 카테고리를 3개씩 그룹화
            const groups = [];

            // 첫 번째 그룹: 전체 (빈 문자열로 설정하여 모든 품목 표시)
            groups.push([
                { name: '전체', value: '' },
                { name: '새로운품목', value: '새로운품목' },
                { name: '기타용품', value: '기타용품' },
            ]);

            for (let i = 0; i < filteredCategories.length; i += 3) {
                const group = [];
                for (let j = 0; j < 3 && i + j < filteredCategories.length; j++) {
                    const category = filteredCategories[i + j];
                    // name은 표시용, value는 실제 검색용
                    group.push({ name: category.name, value: category.name });
                }
                if (group.length > 0) {
                    groups.push(group);
                }
            }

            for (let i = 0; i < this.additionalCategories.length; i += 3) {
                const group = [];
                for (let j = 0; j < 3 && i + j < this.additionalCategories.length; j++) {
                    group.push(this.additionalCategories[i + j]);
                }
                if (group.length > 0) {
                    groups.push(group);
                }
            }

            this.categoryGroups = groups;
        },

        openProductModal() {
            this.showModal_obj.product_new = true;
            this.disableBarcodeScanner();
        },

        closeProductModal() {
            this.showModal_obj.product_new = false;
            // this.enableBarcodeScanner();
        },

        handleProductAdded() {
            this.closeProductModal();
            this.fetchData(); // 목록 새로고침
        },

        formatPrice(price) {
            return price ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
        },

        searchBySetCategory(category) {
            // 다른 섹션의 선택 초기화
            this.selectedCategory = '';
            this.selectedOxygenCategory = null;
            this.selectedAssistanceCategory = null;

            // 현재 섹션 선택 설정
            this.selectedSetCategory = category;
            this.searchQuery = category;
            this.fetchData();
        },

        searchByCategory(category) {
            // 다른 섹션의 선택 초기화
            this.selectedOxygenCategory = null;
            this.selectedAssistanceCategory = null;

            // 현재 섹션 선택 설정
            this.selectedCategory = category;
            this.searchQuery = category;
            this.fetchData();
        },

        searchByOxygenCategory(category) {
            // 다른 섹션의 선택 초기화
            this.selectedCategory = '';
            this.selectedAssistanceCategory = null;

            // 현재 섹션 선택 설정
            this.selectedOxygenCategory = category;
            this.searchQuery = category;
            this.fetchData();
        },

        searchByAssistanceCategory(category) {
            // 다른 섹션의 선택 초기화
            this.selectedCategory = '';
            this.selectedOxygenCategory = null;

            // 현재 섹션 선택 설정
            this.selectedAssistanceCategory = category;
            this.searchQuery = category;
            this.fetchData();
        },

        async fetchData() {
            try {
                let response;

                if (this.searchQuery === '새로운품목') {
                    response = await this.$axios({
                        method: 'get',
                        url: `${this.$apiUrls.hanqmedi}/getNewProducts?companykey=${this.$globalState.company_key}`,
                    });

                    // 새로운 품목 데이터 처리
                    const newProducts = response.data.data.map(product => ({
                        ...product,
                        name: product.name2,
                        name2: product.name3,
                        size: product.size || null,
                        color: product.color || null,
                        buyprice: product.buyprice || 0,
                        rentprice: product.rentprice || 0,
                        target: product.target || '구입'
                    }));

                    this.products_info.products = newProducts;
                    this.products_info.total_cnt = newProducts.length;

                } else if (this.selectedSetCategory === '세트') {
                    // 세트 품목만 조회
                    response = await this.$axios({
                        method: 'get',
                        url: `${this.$apiUrls.hanqmedi}/getAllProducts?search=&companykey=${this.$globalState.company_key}`,
                    });

                    const b_productlist = response.data.data.b_productlist || [];

                    // 세트 품목만 필터링
                    const b_products = b_productlist.flatMap(group => {
                        try {
                            if (!group.products || !Array.isArray(group.products) || group.products.length === 0) {
                                return [];
                            }

                            // 세트 품목만 추출
                            return group.products
                                .filter(product => product.isSet === true)
                                .map(product => ({
                                    ...product,
                                    name: product.name0 || '세트', // 세트 표시
                                    name2: product.set_name || product.name3 || product.name2 || '', // 세트 이름 표시
                                    price: product.price || product.total_price || 0,
                                    target: '구입', // 세트는 구입만 가능
                                    isSet: true,
                                    set_items: product.set_items || [],
                                }));
                        } catch (error) {
                            console.error('세트 제품 데이터 처리 중 오류:', error, group);
                            return [];
                        }
                    });

                    if (b_products.length === 0) {
                        this.$swal.fire({
                            icon: 'info',
                            title: '검색 결과 없음',
                            text: '세트 품목이 없습니다.'
                        });
                    }

                    this.products_info.products = b_products;
                    this.products_info.total_cnt = b_products.length;
                } else {
                    // 기존 전체/카테고리별 조회 (hubServiceNest 요청만 백엔드로 변경)
                    const [bResponse, productListResponse] = await Promise.all([
                        this.$axios({
                            method: 'get',
                            url: `${this.$apiUrls.hanqmedi}/getAllProducts?search=${this.searchQuery}&companykey=${this.$globalState.company_key}`,
                        }),
                        this.$axios({
                            method: 'get',
                            url: `${this.$apiUrls.hanqmedi}/getProductsFromNest`,
                            params: {
                                search: this.searchQuery || ''
                            }
                        })
                    ]);

                    const b_productlist = bResponse.data.data.b_productlist || [];

                    // 모든 개별 제품을 그대로 사용 (사이즈/색상 조합 생성하지 않음)
                    const b_products = b_productlist.flatMap(group => {
                        try {
                            if (!group.products || !Array.isArray(group.products) || group.products.length === 0) {
                                console.warn('유효하지 않은 제품 그룹:', group);
                                return [];
                            }

                            // 각 제품 정보를 그대로 사용하고 필요한 필드만 추가/변환
                            return group.products.map(product => ({
                                ...product,
                                name: product.name2 || product.name3 || '',
                                name2: product.name3 || product.name2 || '',
                                size: product.size || null,
                                color: product.color || null,
                                buyprice: product.buyprice || product.price || 0,
                                rentprice: product.rentprice || product.price2 || 0,
                                target: product.target || '구입',
                                bcode: product.bcode || null,
                                icode: product.icode || null,
                                isSet: product.isSet || false,
                                set_items: product.set_items || []
                            }));
                        } catch (error) {
                            console.error('제품 데이터 처리 중 오류:', error, group);
                            return [];
                        }
                    });

                    const productlist = productListResponse.data || [];

                    // productlist가 배열인지 확인하고 안전하게 처리
                    let processedProductlist = [];
                    if (!Array.isArray(productlist)) {
                        console.warn('productlist가 배열이 아닙니다:', productlist);
                        if (productlist && typeof productlist === 'object') {
                            // 객체인 경우 data 필드나 products 필드를 확인
                            if (Array.isArray(productlist.data)) {
                                processedProductlist = productlist.data;
                            } else if (Array.isArray(productlist.products)) {
                                processedProductlist = productlist.products;
                            } else {
                                processedProductlist = [];
                            }
                        } else {
                            processedProductlist = [];
                        }
                    } else {
                        processedProductlist = productlist;
                    }

                    const normalizedProductlist = processedProductlist.map(product => ({
                        ...product,
                        name: product.pitem || '', // pitem -> name
                        name2: product.pname || '', // pname -> name2
                        size: Array.isArray(product.size) ? product.size.join(', ') : product.size || null,
                        color: Array.isArray(product.color) ? product.color.join(', ') : product.color || null,
                        buyprice: parseInt(product.buy_price) || 0, // buy_price -> buyprice
                        rentprice: parseInt(product.rent_price) || 0, // rent_price -> rentprice
                        target: product.target || '구입',
                        code: product.pcode || null, // pcode -> code
                        company_name: product.company_name || '',
                        state: product.state || '',
                        tax: product.tax || '',
                        price: Array.isArray(product.price) ? product.price.join(', ') : product.price || [],
                        // 급여 품목분류를 위한 필드 추가 - 중요!
                        pitem: product.pitem || '',
                        pname: product.pname || '',
                        pcode: product.pcode || '',
                    }));

                    const combinedProductList = [
                        ...b_products,
                        ...normalizedProductlist
                    ];

                    // 중복 제거 - 바코드, 사이즈, 색상 모두 비교
                    const uniqueProducts = combinedProductList.reduce((acc, current) => {
                        // 필수 필드가 없는 경우 건너뛰기
                        if (!current || !current.name2) {
                            return acc;
                        }

                        const x = acc.find(item =>
                            item.name2 === current.name2 &&
                            item.size === current.size &&
                            item.color === current.color &&
                            item.bcode === current.bcode
                        );
                        if (!x) {
                            return acc.concat([current]);
                        } else {
                            return acc;
                        }
                    }, []);

                    if (uniqueProducts.length === 0) {
                        this.$swal.fire({
                            icon: 'info',
                            title: '검색 결과 없음',
                            text: `'${this.searchQuery}' 검색어에 해당하는 제품이 없습니다.`
                        });
                    } else {
                        this.products_info.products = uniqueProducts;
                    }
                    this.products_info.total_cnt = uniqueProducts.length;
                }

            } catch (error) {
                console.error('데이터를 가져오는 중 오류 발생:', error);
                if (error.response) {
                    console.error('응답 데이터:', error.response.data);
                }
                this.$swal.fire({
                    icon: 'error',
                    title: '오류 발생',
                    text: '데이터를 불러오는 중 오류가 발생했습니다.'
                });
            } finally {
                this.isLoading = false;
            }
        },

        // async fetchData() {
        //     try {
        //         let response;

        //         if (this.searchQuery === '새로운품목') {
        //             response = await this.$axios({
        //                 method: 'get',
        //                 url: `${this.$apiUrls.hanqmedi}/getNewProducts?companykey=${this.$globalState.company_key}`,
        //             });

        //             // 새로운 품목 데이터 처리
        //             const newProducts = response.data.data.map(product => ({
        //                 ...product,
        //                 name: product.name2,
        //                 name2: product.name3,
        //                 size: product.size || null,
        //                 color: product.color || null,
        //                 buyprice: product.buyprice || 0,
        //                 rentprice: product.rentprice || 0,
        //                 target: product.target || '구입'
        //             }));

        //             this.products_info.products = newProducts;
        //             this.products_info.total_cnt = newProducts.length;

        //         } else if (this.selectedSetCategory === '세트') {
        //             // 세트 품목만 조회
        //             response = await this.$axios({
        //                 method: 'get',
        //                 url: `${this.$apiUrls.hanqmedi}/getAllProducts?search=&companykey=${this.$globalState.company_key}`,
        //             });

        //             const b_productlist = response.data.data.b_productlist || [];

        //             // 세트 품목만 필터링
        //             const b_products = b_productlist.flatMap(group => {
        //                 try {
        //                     if (!group.products || !Array.isArray(group.products) || group.products.length === 0) {
        //                         return [];
        //                     }

        //                     // 세트 품목만 추출
        //                     return group.products
        //                         .filter(product => product.isSet === true)
        //                         .map(product => ({
        //                             ...product,
        //                             name: product.name0 || '세트', // 세트 표시
        //                             name2: product.set_name || product.name3 || product.name2 || '', // 세트 이름 표시
        //                             price: product.price || product.total_price || 0,
        //                             target: '구입', // 세트는 구입만 가능
        //                             isSet: true,
        //                             set_items: product.set_items || [],
        //                         }));
        //                 } catch (error) {
        //                     console.error('세트 제품 데이터 처리 중 오류:', error, group);
        //                     return [];
        //                 }
        //             });

        //             if (b_products.length === 0) {
        //                 this.$swal.fire({
        //                     icon: 'info',
        //                     title: '검색 결과 없음',
        //                     text: '세트 품목이 없습니다.'
        //                 });
        //             }

        //             this.products_info.products = b_products;
        //             this.products_info.total_cnt = b_products.length;
        //         } else {
        //             // 기존 전체/카테고리별 조회
        //             response = await this.$axios({
        //                 method: 'get',
        //                 url: `${this.$apiUrls.hanqmedi}/getAllProducts?search=${this.searchQuery}&companykey=${this.$globalState.company_key}`,
        //             });

        //             const b_productlist = response.data.data.b_productlist || [];

        //             // 모든 개별 제품을 그대로 사용 (사이즈/색상 조합 생성하지 않음)
        //             const b_products = b_productlist.flatMap(group => {
        //                 try {
        //                     if (!group.products || !Array.isArray(group.products) || group.products.length === 0) {
        //                         console.warn('유효하지 않은 제품 그룹:', group);
        //                         return [];
        //                     }

        //                     // 각 제품 정보를 그대로 사용하고 필요한 필드만 추가/변환
        //                     return group.products.map(product => ({
        //                         ...product,
        //                         name: product.name2 || product.name3 || '',
        //                         name2: product.name3 || product.name2 || '',
        //                         size: product.size || null,
        //                         color: product.color || null,
        //                         buyprice: product.buyprice || product.price || 0,
        //                         rentprice: product.rentprice || product.price2 || 0,
        //                         target: product.target || '구입',
        //                         bcode: product.bcode || null,
        //                         isSet: product.isSet || false,
        //                         set_items: product.set_items || []
        //                     }));
        //                 } catch (error) {
        //                     console.error('제품 데이터 처리 중 오류:', error, group);
        //                     return [];
        //                 }
        //             });

        //             const productlist = response.data.data.productlist || [];

        //             const normalizedProductlist = productlist.map(product => ({
        //                 ...product,
        //                 name: product.name || '',
        //                 name2: product.name2 || '',
        //                 size: product.size || null,
        //                 color: product.color || null,
        //                 buyprice: product.buyprice || product.price || 0,
        //                 rentprice: product.rentprice || product.price2 || 0,
        //                 target: product.target || '구입',
        //                 // productlist의 경우 code 필드를 bcode로도 설정
        //                 bcode: product.code || product.bcode || null,
        //                 code: product.code || null
        //             }));

        //             const combinedProductList = [
        //                 ...b_products,
        //                 ...normalizedProductlist
        //             ];

        //             // 중복 제거 - 바코드, 사이즈, 색상 모두 비교
        //             const uniqueProducts = combinedProductList.reduce((acc, current) => {
        //                 // 필수 필드가 없는 경우 건너뛰기
        //                 if (!current || !current.name2) {
        //                     return acc;
        //                 }

        //                 const x = acc.find(item =>
        //                     item.name2 === current.name2 &&
        //                     item.size === current.size &&
        //                     item.color === current.color &&
        //                     item.bcode === current.bcode
        //                 );
        //                 if (!x) {
        //                     return acc.concat([current]);
        //                 } else {
        //                     return acc;
        //                 }
        //             }, []);

        //             if (uniqueProducts.length === 0) {
        //                 this.$swal.fire({
        //                     icon: 'info',
        //                     title: '검색 결과 없음',
        //                     text: `'${this.searchQuery}' 검색어에 해당하는 제품이 없습니다.`
        //                 });
        //             } else {
        //                 this.products_info.products = uniqueProducts;
        //             }
        //             this.products_info.total_cnt = uniqueProducts.length;
        //         }

        //     } catch (error) {
        //         console.error('데이터를 가져오는 중 오류 발생:', error);
        //         if (error.response) {
        //             console.error('응답 데이터:', error.response.data);
        //         }
        //         this.$swal.fire({
        //             icon: 'error',
        //             title: '오류 발생',
        //             text: '데이터를 불러오는 중 오류가 발생했습니다.'
        //         });
        //     } finally {
        //         this.isLoading = false;
        //     }
        // },

        // productGetTableTr클릭시 해당 품목의 상세정보를 OrderUpPage로 전달
        async productDetail(product) {

            let currentProduct = { ...product }; // 현재 제품의 복사본 생성
            console.log('ProductGetPage - 전달할 제품 정보:', currentProduct);

            // 세트 품목 처리
            if (currentProduct.isSet && currentProduct.set_items && currentProduct.set_items.length > 0) {
                try {
                    // 세트 내 개별 품목들 추가
                    for (const item of currentProduct.set_items) {
                        // 가격과 수량 계산
                        const itemPrice = item.price || 0;
                        const itemQuantity = item.quantity || 1;

                        const setItemProduct = {
                            num: item.product_set_id,
                            name: item.category || '세트 품목', // 카테고리 정보
                            name1: item.category || '세트 품목', // 품목분류 정보
                            name2: item.name || '', // 품목명
                            name3: item.name || '', // 추가 정보
                            name4: `${itemQuantity}개`, // 수량 정보
                            category: item.category || '',
                            quantity: itemQuantity, // 세트 아이템의 수량 사용
                            price: itemPrice,
                            buyprice: itemPrice, // 세트 아이템의 가격을 buyprice로 설정
                            rentprice: 0,
                            target: '구입',
                            selected_target: '구입',
                            barcodes: [''],
                            colors: [''],
                            sizes: [''],
                            notes: [''],
                            options: {
                                bcode: [''],
                                color: [''],
                                size: [''],
                                note: ['']
                            },
                            colorOptions: [],
                            sizeOptions: [],
                            setBuyprice: itemPrice * itemQuantity, // 총 가격 계산
                            setRentprice: 0,
                            unitprice: itemPrice,
                            setUnitprice: itemPrice * itemQuantity,
                            selectedPrice: itemPrice,
                            isSetItem: true, // 이 플래그로 세트 구성품임을 표시
                            product_set_id: item.product_set_id || null,
                            set_name: currentProduct.set_name || '', // 상위 세트 이름 사용
                            set_item_id: item.id || null, // 세트 아이템 ID 추가
                            set_items: [item] // 세트 아이템 정보 추가
                        };

                        // 세트 구성품 추가
                        this.$emit('productDetail', setItemProduct);
                    }

                    this.tost_alert('success', `${currentProduct.set_name || currentProduct.name3 || '세트'} 세트 구성품이 추가되었습니다.`);
                    return;
                } catch (error) {
                    console.error('세트 상세 정보 로드 중 오류 발생:', error);
                    this.tost_alert('error', '세트 정보를 불러오는데 실패했습니다.');
                    return;
                }
            }

            // 산소발생기 체크
            const isCurrentOxygenGenerator = currentProduct.name1 === '산소발생기';
            const hasExistingOxygenGenerator = this.existingProducts?.some(p => p.name1 === '산소발생기');

            // 현재 제품이 산소발생기가 아닌데 기존에 산소발생기가 있는 경우
            if (!isCurrentOxygenGenerator && hasExistingOxygenGenerator) {
                this.tost_alert('warning', '산소발생기가 있는 주문서에는 일반 품목을 추가할 수 없습니다.');
                return;
            }

            // 현재 제품이 산소발생기인데 기존에 일반 제품이 있는 경우
            if (isCurrentOxygenGenerator && this.existingProducts?.length > 0 && !hasExistingOxygenGenerator) {
                this.tost_alert('warning', '일반 품목이 있는 주문서에는 산소발생기를 추가할 수 없습니다.');
                return;
            }

            // 구입/대여 선택 확인 및 selected_target 설정
            if (currentProduct.target === '구입 또는 대여' && !currentProduct.selected_target) {
                this.tost_alert('warning', '구입 또는 대여를 선택해주세요.');
                return;
            }

            // 현재 제품의 유효 타겟(effectiveTarget) 결정
            // 구입 또는 대여라면 사용자가 선택한 구입/대여 값, 아닐 경우엔 target 그대로 사용
            let effectiveTarget = currentProduct.target === '구입 또는 대여'
                ? currentProduct.selected_target
                : currentProduct.target;

            // 구입 또는 대여가 아닌 경우 selected_target을 effectiveTarget로 할당
            if (currentProduct.target !== '구입 또는 대여') {
                currentProduct.selected_target = effectiveTarget;
            }

            // 기존 주문서와 타겟 타입 체크
            if (this.existingTarget !== null) {
                if (effectiveTarget !== this.existingTarget) {
                    this.tost_alert('warning', `현재 주문에는 ${this.existingTarget} 제품만 추가할 수 있습니다.`);
                    return;
                }

                // 중복 체크
                const existingProduct = this.existingProducts.find(p =>
                    p.code === currentProduct.code &&
                    p.size === currentProduct.size &&
                    p.color === currentProduct.color &&
                    p.name2 === currentProduct.name2 &&  // 품목명 비교 추가
                    p.bcode === currentProduct.bcode &&  // 바코드 비교 추가
                    (p.selected_target || p.target) === effectiveTarget
                );

                if (existingProduct) {
                    // 수량 증가
                    existingProduct.quantity += 1;

                    // 바코드 정보 생성 - 급여 품목은 빈 바코드
                    const barcodeWithIcode = currentProduct.num >= 1000000
                        ? (currentProduct.name0?.startsWith('당뇨용품') && currentProduct.icode
                            ? `${currentProduct.bcode || ''} (${currentProduct.icode})`
                            : currentProduct.bcode || '')
                        : ''; // 급여 품목은 빈 바코드

                    // 배열 확장
                    existingProduct.barcodes.push(barcodeWithIcode);
                    existingProduct.colors.push(existingProduct.colorOptions[0] || '');
                    existingProduct.sizes.push(existingProduct.sizeOptions[0] || '');
                    existingProduct.notes.push('');

                    if (existingProduct.options) {
                        existingProduct.options.bcode.push(barcodeWithIcode);
                        existingProduct.options.color.push(existingProduct.colorOptions[0] || '');
                        existingProduct.options.size.push(existingProduct.sizeOptions[0] || '');
                        existingProduct.options.note.push('');
                    }

                    // 단가 재계산
                    existingProduct.setUnitprice = (existingProduct.selected_target === '대여' ?
                        existingProduct.rentprice : existingProduct.buyprice) * existingProduct.quantity;

                    this.$emit('updateProduct', existingProduct);
                    this.tost_alert('success', `${currentProduct.name2} 수량이 증가되었습니다.`);
                    return;
                }
            }

            // 기본값 설정 추가
            currentProduct = {
                color: '',
                size: '',
                quantity: 1,
                barcodes: [''],
                colors: [''],
                sizes: [''],
                notes: [''],
                options: {
                    bcode: [''],
                    color: [''],
                    size: [''],
                    note: ['']
                },
                colorOptions: [],
                sizeOptions: [],
                ...currentProduct,
                isEditingPrice: false
            };

            try {
                // 공통 속성 설정
                const baseProduct = {
                    ...currentProduct,
                    selected_target: currentProduct.selected_target,
                    selectedPrice: currentProduct.selectedPrice || currentProduct.price,
                    unitprice: currentProduct.selected_target === '대여' ?
                        (currentProduct.rentprice || 0) : (currentProduct.buyprice || 0),
                    setBuyprice: currentProduct.selected_target === '대여' ?
                        0 : (currentProduct.buyprice || 0),
                    setRentprice: currentProduct.selected_target === '대여' ?
                        (currentProduct.rentprice || 0) : 0,
                    setUnitprice: (currentProduct.selected_target === '대여' ?
                        (currentProduct.rentprice || 0) : (currentProduct.buyprice || 0)) *
                        (currentProduct.quantity || 1),
                    colorOptions: [],
                    colors: [],
                    sizeOptions: [],
                    sizes: [],
                    ...(currentProduct.icode ? { icode: currentProduct.icode } : {}),
                    // 급여 품목(num < 1000000)인 경우 빈 바코드로 설정
                    barcodes: Array(currentProduct.quantity || 1).fill(
                        currentProduct.num >= 1000000
                            ? (currentProduct.name0?.startsWith('당뇨용품') && currentProduct.icode
                                ? `${currentProduct.bcode || ''} (${currentProduct.icode})`
                                : currentProduct.bcode || '')
                            : '' // 급여 품목은 빈 바코드
                    ),
                    // 급여 품목분류 필드 명시적으로 설정
                    pitem: currentProduct.pitem || '',
                    pname: currentProduct.pname || '',
                    pcode: currentProduct.pcode || '',
                };

                try {
                    // API에서 데이터를 가져오기 전에 기본 배열 설정
                    baseProduct.colorOptions = [];
                    baseProduct.colors = Array(currentProduct.quantity || 1).fill('');
                    baseProduct.sizeOptions = [];
                    baseProduct.sizes = Array(currentProduct.quantity || 1).fill('');

                    if (!currentProduct.name0) {
                        // API 호출
                        const response = await this.$axios.post(`${this.$apiUrls.hanq}/orderupproductload`, {
                            target: currentProduct.target,
                            number: currentProduct.code
                        });

                        // API 응답 안전하게 처리
                        if (response.data && response.data.result && response.data.result[0]) {
                            const result = response.data.result[0];

                            if (result.color) {
                                baseProduct.colorOptions = result.color.split(",");
                                baseProduct.colors = Array(currentProduct.quantity || 1)
                                    .fill(baseProduct.colorOptions[0] || '');
                            }

                            if (result.size) {
                                baseProduct.sizeOptions = result.size.split(",");
                                baseProduct.sizes = Array(currentProduct.quantity || 1)
                                    .fill(baseProduct.sizeOptions[0] || '');
                            }
                        }
                    } else {
                        // 직접 데이터가 있는 경우
                        if (currentProduct.color) {
                            baseProduct.colorOptions = currentProduct.color.split(",");
                            baseProduct.colors = Array(currentProduct.quantity || 1)
                                .fill(baseProduct.colorOptions[0] || '');
                        }
                        if (currentProduct.size) {
                            baseProduct.sizeOptions = currentProduct.size.split(",");
                            baseProduct.sizes = Array(currentProduct.quantity || 1)
                                .fill(baseProduct.sizeOptions[0] || '');
                        }
                    }
                } catch (apiError) {
                    console.warn('API 호출 중 오류 발생:', apiError);
                    // API 오류 시 기본값 유지
                }

                // 제품 정보 emit
                this.$emit('productDetail', baseProduct); // 상위 컴포넌트에 데이터 전달 (OrderUpPage, OrderModifyPage)
                this.tost_alert('success', `${currentProduct.name2} 품목이 추가되었습니다.`);

            } catch (error) {
                console.error('제품 상세 정보 로드 중 오류 발생:', error);
                this.tost_alert('error', '제품 정보를 불러오는데 실패했습니다.');
            }
        },
        productModalClose() {
            this.$emit('close');
        },
        createToast() {
            return this.$swal.mixin({
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
                customClass: {
                    container: 'custom-toast-container'
                },
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            });
        },
        tost_alert(icon, txt) {
            this.createToast().fire({
                icon: icon,
                title: txt
            });
        },
        updateTarget(product, target) {
            if (product.target === '구입 또는 대여') {
                product.selected_target = target;

                if (target === '구입') {
                    product.selectedPrice = product.buyprice;
                    product.price = product.buyprice;
                } else if (target === '대여') {
                    product.selectedPrice = product.rentprice;
                    product.price = product.rentprice;
                }
            }

            this.$nextTick(() => {
                this.productDetail(product);
            });
        },
        // 이미지 URL을 생성하는 공통 헬퍼 함수 (타임스탬프 포함)
        _buildImageUrl(value, timestamp) {
            const s3BaseUrl = this.$apiUrls.s3Bucket;
            return `${s3BaseUrl}/Product-image/${value}.jpg?t=${timestamp}`;
        },
        // 1. product 정보로 이미지 URL을 반환
        async getImageUrl(product) {
            if (!product) return null;

            const timestamp = new Date().getTime();
            const checkImageExists = (url) => {
                return new Promise((resolve) => {
                    const img = new Image();
                    img.onload = () => resolve(url);
                    img.onerror = () => resolve(null);
                    img.src = url;
                });
            };

            try {
                // num으로 먼저 시도
                if (product.num) {
                    const numUrl = this._buildImageUrl(product.num, timestamp);
                    const result = await checkImageExists(numUrl);
                    if (result) return result;
                }

                // code로 시도
                if (product.code?.trim()) {
                    const codeUrl = this._buildImageUrl(product.code, timestamp);
                    const result = await checkImageExists(codeUrl);
                    if (result) return result;
                }

                // return DefaultIcon;
            } catch (error) {
                console.error('이미지 URL 생성 중 오류:', error);
                // return DefaultIcon;
            }
        },

        // 2. 이미지 로드 에러 처리
        handleImageError(e) {
            e.target.onerror = null;
            this.isDefaultImage = true;
            // this.imageUrl = DefaultIcon;
        },

        // 3. 이미지 모달 표시
        async showProductImage(product) {
            this.imageUrl = null;  // 초기화
            this.selectedProduct = null;  // 초기화

            const url = await this.getImageUrl(product);
            if (url) {
                this.imageUrl = url;
                this.selectedProduct = { ...product };
                // this.isDefaultImage = url === DefaultIcon;
            }
        },
        closeProductImage() {
            this.selectedProduct = null;
        },
        handleEscKey(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                this.$emit('close');
            }
        },

        disableBarcodeScanner() {
            try {
                if (document && document.scannerDetectionData) {
                    onScan.detachFrom(document);
                }
            } catch (error) {
                console.log('바코드 스캐너 비활성화 중 오류:', error);
            }
        },
    },

    async created() {
        document.addEventListener('keydown', this.handleEscKey);
        await this.fetchAllCategories();
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.handleEscKey);
    }
};
</script>

<style>
.custom-toast-container {
    margin-top: 100px !important;
}

.product-image {
    width: 400px;
    height: 400px;
    object-fit: contain;
    background-color: white;
    display: block;
    margin: 0 auto;
}

/* 이미지 컨테이너 스타일 */
.product-image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px;
    background-color: white;
}
</style>